import { TableHeadersType } from "../tableHeadersType";

export const RECURRING_JOBS_SETTING_LIST_TABLE_HEADER:TableHeadersType[]=[
    {
        "label": "CODE",
        "value": "client_code",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CLIENT",
        "value": "client_name",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "JOB TYPE",
        "value": "job_type",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "PERIOD LENGTH",
        "value": "period_length",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "NEXT PERIOD END",
        "value": "next_period_end",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CREATE JOB AT",
        "value": "create_job_at",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label":"ADDED/MODIFIED BY",
        "value":"updated_by",
        "defaultChecked":true,
        "checked":true
    },
]